<ng-container *ngIf="isValidTag">
  <div class="memberRateTag {{extraClass}}">
    <app-ds-tag-member
      [size]="tagMemberSize"
      [type]="tagMemberType"
      [label]="label | transloco">
    </app-ds-tag-member>
  </div>
</ng-container>